export enum AuditRecordType {
  Course = 1,
  License = 2,
  CourseSession = 3,
  CourseSessionAttendee = 4,
}
